import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

// Swiper docs: https://swiperjs.com/api/
$(document).ready(function () {
	$('.module-products .swiper-container').each(function () {
		initSlide(this, {
			slidesPerView: 'auto',
			centeredSlides: true,
			loop: true,
			slideActiveClass: 'swiper-slide-active md:children:bg-secondary md:children:-my-3 md:children:-mx-2 md:children:py-11 children:z-20',
			slideAdjacentPrevClass: 'md:fade-out-right',
			slideAdjacentNextClass: 'md:fade-out-left',
			autoplay: {
				delay: 4000,
			},
			speed: 500,
		})
	})
	$('.module-slider .swiper-container, .module-cases .swiper-container').each(function () {
		initSlide(this, {
			slidesPerView: 'auto',
			centeredSlides: true,
			loop: true,
			autoplay: {
				delay: 4000,
			},
			speed: 1000,
		})
	})
	$('.module-customers .swiper-container').each(function () {
		initSlide(this, {
			slidesPerView: 'auto',
			centeredSlides: true,
			loop: true,
			autoplay: {
				delay: 4000,
			},
			speed: 1000,
		})
	})
	updateSliders()
})
// make sure slides fit window when all content has loaded
$(window).on('load', function () {
	updateSliders()
})

function initSlide(slide, userOptions) {
	let defaultOptions = {
		watchOverflow: true,
		observer: true,
		slideAdjacentPrevClass: '',
		slideAdjacentNextClass: '',
	}
	let options = Object.assign({
		pagination: {
			el: $(slide).find('.swiper-pagination')[0],
			type: 'fraction',
			clickable: true,
		},
		navigation: {
			nextEl: $(slide).find('.swiper-button-next')[0],
			prevEl: $(slide).find('.swiper-button-prev')[0],
		},
		scrollbar: {
			el: $(slide).find('.swiper-scrollbar')[0],
		},
		on: {
			slideChange: (swiper) => updateSlideClasses(swiper, (userOptions || defaultOptions)),
			transitionStart: (swiper) => updateSlideClasses(swiper, (userOptions || defaultOptions)),
		},
	}, (userOptions || defaultOptions))
	return new Swiper(slide, options)
}

export function makeSlider(className, options) {
	return initSlide(className, options)
}

function updateSliders() {
	window.dispatchEvent(new Event('resize'));
	$(window).trigger('resize');
	setTimeout(function () {
		// just to be sure
		window.dispatchEvent(new Event('resize'));
		$(window).trigger('resize');
	}, 300)
}

function updateSlideClasses(swiper, params) {
	const { slides } = swiper;
	const { slideAdjacentPrevClass, slideAdjacentNextClass } = params

	// Remove any previous adjacent classes
	slides.forEach(slide => {
		slide.classList.remove(slideAdjacentPrevClass, slideAdjacentNextClass);
	});

	// Loop through all slides and check for the prev and next slides
	slides.forEach(slide => {
		if (slide.classList.contains('swiper-slide-prev')) {
			const prevSlide = slide.previousElementSibling;
			if (prevSlide) {
				prevSlide.classList.add(slideAdjacentPrevClass); // Add class to slide before "swiper-slide-prev"
			}
		}

		if (slide.classList.contains('swiper-slide-next')) {
			const nextSlide = slide.nextElementSibling;
			if (nextSlide) {
				nextSlide.classList.add(slideAdjacentNextClass); // Add class to slide after "swiper-slide-next"
			}
		}
	});
}
